var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.errors),function(error,i){return _c('div',{key:i,staticClass:"error-wrapper"},[_c('UiErrorMessageInput',{attrs:{"error":error}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }